module.exports = __webpack_public_path__ + "img/dj_down.9494b5f8.png";